import { Component, input, OnInit, signal } from '@angular/core';
import { PointCategory } from '@shared/interfaces/points';

@Component({
  selector: 'idel-points-categories',
  templateUrl: './points-categories.component.html',
  styleUrl: './points-categories.component.scss',
})
export class PointsCategoriesComponent implements OnInit {
  public readonly categories = input.required<PointCategory[][]>();
  public readonly defaultCategory = input<PointCategory | null>();

  public readonly currentActiveCategoryIndex = signal<[number, number]>([-1, -1]);

  public ngOnInit(): void {
    this.setDefaultCategoryIfExists();
  }

  private setDefaultCategoryIfExists(): void {
    const defaultCategory = this.defaultCategory();

    if (!defaultCategory) return;

    for (let i = 0; i < this.categories().length; i++) {
      for (let j = 0; j < this.categories()[i].length; j++) {
        const cat = this.categories()[i][j];

        if (cat.label === defaultCategory.label) {
          this.currentActiveCategoryIndex.set([i, j]);
          break;
        }
      }
    }
  }
}
